import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import {
  createInterview,
  createLastChatSortIndex,
  deleteInterview,
  updateInterview,
} from "graphql/mutations";
import { getInterview, listInterviewSortBySeq } from "graphql/queries";
import {
  CreateInterviewInput,
  DeleteInterviewInput,
  GetInterviewQuery,
  Interview,
  ListInterviewSortBySeqQuery,
  ModelSortDirection,
  UpdateInterviewInput,
} from "types/graphqlapi";

export const getInterviewByIdQuery = async (id: string | undefined) => {
  if (id === undefined) return;
  try {
    const result = (await API.graphql(
      graphqlOperation(getInterview, {
        id: id,
      })
    )) as {
      data: GetInterviewQuery;
    };

    const interview = result?.data?.getInterview;

    return interview;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const listInterviewsQuery = async (
  subjectId: string
): Promise<Interview[]> => {
  let list: Interview[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listInterviewSortBySeq, {
        subject_id: subjectId,
        sortDirection: ModelSortDirection.DESC,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListInterviewSortBySeqQuery;
    };
    const data = result.data.listInterviewSortBySeq;
    const items = (data?.items || []) as Interview[];

    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};

export const createInterviewMutation = async (
  createInterviewInput: CreateInterviewInput
): Promise<string | undefined> => {
  try {
    // SEQMAX取得して設定する。
    const resultSeq = (await API.graphql(
      graphqlOperation(listInterviewSortBySeq, {
        subject_id: createInterviewInput.subject_id,
        sortDirection: ModelSortDirection.DESC,
        limit: 1,
      })
    )) as {
      data: ListInterviewSortBySeqQuery;
    };

    createInterviewInput.interview_seq = resultSeq.data.listInterviewSortBySeq
      ?.items
      ? resultSeq.data.listInterviewSortBySeq.items[0]
        ? resultSeq.data.listInterviewSortBySeq.items[0].interview_seq + 1
        : 1
      : 1;
    const createdInterview = (await API.graphql(
      graphqlOperation(createInterview, { input: createInterviewInput })
    )) as GraphQLResult<{
      createInterview: Interview;
    }>;

    const createdInterviewId = createdInterview.data?.createInterview?.id;
    if (!createdInterviewId) throw new Error("CreateInterviewFailed");

    //ChatDataの最大インデックス管理レコード作成
    await API.graphql(
      graphqlOperation(createLastChatSortIndex, {
        input: {
          interview_id: createdInterviewId,
          chat_sort_index: 0,
        },
      })
    );

    return createdInterviewId;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const updateInterviewMutation = async (
  updateInterviewInput: UpdateInterviewInput
) => {
  try {
    return (await API.graphql(
      graphqlOperation(updateInterview, { input: updateInterviewInput })
    )) as GraphQLResult<{ updateInterview: Interview }>;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const deleteInterviewMutation = async (
  deleteInterviewInput: DeleteInterviewInput
) => {
  try {
    await API.graphql(
      graphqlOperation(deleteInterview, { input: deleteInterviewInput })
    );
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};
